export default [
  {
    id: 5,
    amount: 69000,
    campaign: "کمپین بنری روپلاک کاسپین ۱۴۰۱",
    status: 1,
    returned_at: "1401/08/05",
    created_at: "1401/08/11",
  },
  {
    id: 4,
    amount: 3200,
    campaign: "کمپین بنری روز مرد ۱۴۰۰",
    status: 2,
    returned_at: "1400/11/25",
    created_at: "1400/11/29",
  },
  {
    id: 3,
    amount: 5100,
    campaign: "کمپین بنری روز زن ۱۴۰۰",
    status: 2,
    returned_at: "1400/01/02",
    created_at: "1400/01/05",
  },
  {
    id: 2,
    amount: 13333,
    campaign: "کمپین بنری عید فطر ۱۴۰۰	",
    status: 2,
    returned_at: "1400/02/22",
    created_at: "1400/02/27",
  },
  {
    id: 1,
    amount: 33000,
    campaign: "کمپین بنری عید نوروز ۱۴۰۰",
    status: 2,
    returned_at: "1399/12/29",
    created_at: "1400/01/21",
  },
];
